import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    selectAllTags: (count: number) =>
      translate({ id: 'components.tagsList.button.selectAll', values: { count } }),
    deselectAllTags: (count: number) =>
      translate({ id: 'components.tagsList.button.deselectAll', values: { count } }),
    disabledTooltip: translate({ id: 'components.tagsList.disabledTag' }),
    placeholder: translate({ id: 'components.tagsList.search.placeholder' }),
    clearSearch: translate({ id: 'components.tagsList.button.clear' }),
    emptyTags: translate({ id: 'components.tagsList.suggestionsList.empty' }),
  }))

  return api
}
